import {
  ISetComplaintReplyBody,
  ISetComplaintReplyResponse,
} from "../../utils/types";
import { apiManager } from "../api-manager";

export const sendComplaintReply = async (body: ISetComplaintReplyBody) => {
  const res = await apiManager.post<ISetComplaintReplyResponse>(
    `/helpdesk/send-message`,
    {
      ...body,
      userType: "admin",
    }
  );
  return res;
};
